export default __webpack_public_path__ + "static/media/user-feed5.bb231c0d.png";